import { type QueryHookOptions, useQuery } from "@apollo/client";
import { CountryAccessesListQuery } from "../graphql/queries";
import type {
  CountryAccessesListQueryType,
  CountryAccessesListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useCountryAccessesQuery = (
  options?: QueryHookOptions<
    CountryAccessesListQueryType,
    CountryAccessesListQueryVariablesType
  >
) => {
  return useQuery<
    CountryAccessesListQueryType,
    CountryAccessesListQueryVariablesType
  >(CountryAccessesListQuery, options);
};
